import { Component, OnInit } from '@angular/core';
import { Http } from '@angular/http';

@Component({
    selector: 'app-client-query',
    templateUrl: './client-query.component.html',
    styleUrls: ['./client-query.component.css']
})
export class ClientQueryComponent implements OnInit {

    private Url: string = 'http://www.solventc.com/api/Email.asmx/SendEmail';

    constructor(private http: Http) { }

    ngOnInit() {
    }

    sendEmail(detail) {

        this.http.post(this.Url, detail.value)
            .subscribe(response => {
                detail.reset();
                alert((response.json())["d"]);
            });

        return false;
    }

}



// WEBPACK FOOTER //
// F:/Projects/tfs/VS2015/SolventC/SolventCWebsite/Angular4.Website/src/app/client-query/client-query.component.ts